import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const listenersRef = useRef([]);

    useEffect(() => {
      listenersRef.current.forEach(fn => fn(location));
    }, [location]);

    const history = {
      push: navigate,
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      location: location,
      listen: (fn) => {
        listenersRef.current.push(fn);
        return () => {
          listenersRef.current = listenersRef.current.filter(f => f !== fn);
        };
      }
    };

    const match = {
      params: params,
      path: location.pathname,
      url: location.pathname,
      isExact: true,
    };

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        match={match}
        history={history}
      />
    );
  }
  return ComponentWithRouterProp;
}
